import { render, staticRenderFns } from "./AcceptCertificationModal.vue?vue&type=template&id=f6e198d6&scoped=true&"
import script from "./AcceptCertificationModal.vue?vue&type=script&lang=js&"
export * from "./AcceptCertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e198d6",
  null
  
)

export default component.exports